import { Outlet } from 'react-router-dom';

export function TenantsRoot() {
  return <Outlet />;
}
